export default __webpack_public_path__ + "static/media/login_help.9fce38b5.svg";